// extracted by mini-css-extract-plugin
export default {"nodesTitle":"styles_nodesTitle__aK73S","dragNDrop":"styles_dragNDrop__9ScL8"};